import { z } from "zod";
import type {
  CandidateEducation,
  CandidateExperience,
  CandidateProject,
  CandidateProfileLink,
} from "@artha/types";
import {
  CANDIDATE_PROFILE_DATE_MAX_LENGTH,
  CANDIDATE_PROFILE_DESCRIPTION_MAX_LENGTH,
  CANDIDATE_PROFILE_URL_MAX_LENGTH,
} from "./candidate-profile.constants";

const CandidateProfilePeriodSchema = z.object({
  startDate: z
    .string()
    .trim()
    .max(CANDIDATE_PROFILE_DATE_MAX_LENGTH)
    .optional(),
  endDate: z.string().trim().max(CANDIDATE_PROFILE_DATE_MAX_LENGTH).optional(),
  isCurrent: z.boolean().optional(),
});

export const CandidateEducationSchema = CandidateProfilePeriodSchema.extend({
  level: z.string().trim().max(120).optional(),
  field: z.string().trim().max(160).optional(),
  institution: z.string().trim().max(200).optional(),
  grade: z.string().trim().max(120).optional(),
  description: z
    .string()
    .trim()
    .max(CANDIDATE_PROFILE_DESCRIPTION_MAX_LENGTH)
    .optional(),
}) satisfies z.ZodType<CandidateEducation>;

export const CandidateExperienceSchema = CandidateProfilePeriodSchema.extend({
  title: z.string().trim().max(120).optional(),
  company: z.string().trim().max(200).optional(),
  employmentType: z.string().trim().max(80).optional(),
  location: z.string().trim().max(240).optional(),
  description: z
    .string()
    .trim()
    .max(CANDIDATE_PROFILE_DESCRIPTION_MAX_LENGTH)
    .optional(),
}) satisfies z.ZodType<CandidateExperience>;

export const CandidateProjectSchema = CandidateProfilePeriodSchema.extend({
  name: z.string().trim().max(200).optional(),
  organization: z.string().trim().max(200).optional(),
  description: z
    .string()
    .trim()
    .max(CANDIDATE_PROFILE_DESCRIPTION_MAX_LENGTH)
    .optional(),
  url: z
    .union([
      z.literal(""),
      z.url({ protocol: /^https?$/ }).max(CANDIDATE_PROFILE_URL_MAX_LENGTH),
    ])
    .optional(),
}) satisfies z.ZodType<CandidateProject>;

export type CandidateEducationDto = z.infer<typeof CandidateEducationSchema>;
export type CandidateExperienceDto = z.infer<typeof CandidateExperienceSchema>;
export type CandidateProjectDto = z.infer<typeof CandidateProjectSchema>;

export const CandidateProfileLinkSchema = z.object({
  label: z.string().trim().max(80).optional(),
  url: z.url({ protocol: /^https?$/ }).max(CANDIDATE_PROFILE_URL_MAX_LENGTH),
}) satisfies z.ZodType<CandidateProfileLink>;
export type CandidateProfileLinkDto = z.infer<typeof CandidateProfileLinkSchema>;
